import { adverseOnboarding } from './adverseEvents'
import { appealsOnboarding } from './appeals'
import { staffOnboarding } from './staff'
import { auditsOnboarding } from './audits'
import { improvementsOnboarding } from './improvements'
import { settingsOnboarding } from './settings'
import { sharedOnboarding } from './shared'
import { tasksOnboarding } from './tasks'
import { ticketsOnboarding } from './tickets'
import type { IOnboardingModule } from '../types/IOnboardingModule'
import type { IOnboardingScenario } from '../types/IOnboardingScenario'
import type { IOnboardingStepText } from '../types/IOnboardingStepText'

/**
 * Все модули с онбордингом. Новый модуль подключается так:
 * 1. папка `scenarios/<модуль>/` с якорями, шагами, текстами и условиями;
 * 2. якоря `data-onboarding` в разметке (значения — из `anchors.ts` модуля);
 * 3. `useOnboardingContext()` в экранах и формах, по которым идут шаги;
 * 4. `useOnboardingDemoRows()` на отображаемый список таблицы и демо-режим формы;
 * 5. `OnboardingLaunchButton` в тулбаре и «ушках», `autoStart()` на главном экране;
 * 6. модуль добавляется в этот список.
 */
const modules: IOnboardingModule[] = [
  sharedOnboarding,
  ticketsOnboarding,
  tasksOnboarding,
  improvementsOnboarding,
  auditsOnboarding,
  adverseOnboarding,
  appealsOnboarding,
  staffOnboarding,
  settingsOnboarding,
]

/*
 * Тексты модулей сливаются в один словарь. Модуль может переопределить текст шага общего фрагмента,
 * объявив свой ключ вида «модуль.шаг» и сославшись на него в сценарии.
 */
const texts: Record<string, IOnboardingStepText> = Object.assign({}, ...modules.map(module => module.texts))
const conditions: Record<string, () => boolean> = Object.assign({}, ...modules.map(module => module.conditions))
const scenarios: IOnboardingScenario[] = modules.flatMap(module => module.scenarios)

export function findScenario(id: string): IOnboardingScenario | null {
  return scenarios.find(scenario => scenario.id === id) ?? null
}

export function resolveStepText(stepId: string): IOnboardingStepText {
  const text = texts[stepId]
  if (!text)
    console.warn(`[onboarding] Нет текста для шага «${stepId}»`)

  return text ?? { title: stepId, text: '' }
}

/** Неизвестное условие считается ложным — шаг пропускается */
export function resolveCondition(name: string): boolean {
  const condition = conditions[name]
  if (!condition) {
    console.warn(`[onboarding] Нет условия «${name}»`)

    return false
  }

  return condition()
}
